import React from 'react'
import { Loader } from '@klarna/bubble-ui'

import styles from './LoadingSpinner.css'

function LoadingSpinner() {
  return (
    <span>
      <style>{styles}</style>
      <div className="loader"><Loader/></div>
    </span>
  )
}

export default LoadingSpinner
